module.exports = __webpack_public_path__ + "files/3f3002350568816d801680807bd7cce9.png";